// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ActionPlanBoardWidget_board__3cND8 {
  width: 100%;
}

.ActionPlanBoardWidget_state__xNLeu,
.ActionPlanBoardWidget_error__yvvIP {
  padding: 12px;
  border-radius: 8px;
  background: #fff;
}

.ActionPlanBoardWidget_error__yvvIP {
  color: #b42318;
}

.ActionPlanBoardWidget_columns__tx0P3 {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
  align-items: stretch;
}

.ActionPlanBoardWidget_column__6sKaX {
  min-height: 500px;
  display: flex;
  flex-direction: column;
  padding: 14px;
  border: 1px solid #e2e7eb;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.58);
}

.ActionPlanBoardWidget_highlighted__NfUDr {
  box-shadow: inset 0 0 0 2px rgba(21, 90, 168, 0.12);
}

.ActionPlanBoardWidget_columnHeader__omtGZ {
  display: grid;
  grid-template-columns: auto auto 1fr;
  align-items: center;
  gap: 9px;
  margin-bottom: 12px;
}

.ActionPlanBoardWidget_columnHeader__omtGZ h2 {
  margin: 0;
  color: #1c3445;
  font-size: 1rem;
  font-weight: 700;
}

.ActionPlanBoardWidget_count__hbJFy {
  justify-self: start;
  color: #98a3ad;
  font-size: 0.82rem;
  font-weight: 700;
}

.ActionPlanBoardWidget_columnIcon__V2eBz {
  width: 30px;
  height: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 1rem;
  font-weight: 700;
}

.ActionPlanBoardWidget_need__ZrJI7 {
  background: #e8f5fb;
  color: #2797c7;
}

.ActionPlanBoardWidget_proposal__i4piK {
  background: #fff2e6;
  color: #ff8b43;
}

.ActionPlanBoardWidget_appointment__XlfLy {
  background: #e9f9ef;
  color: #2fac68;
}

.ActionPlanBoardWidget_items__2wNBh {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.ActionPlanBoardWidget_empty__RQ-HN {
  margin: 12px 0;
  color: #87949e;
  font-size: 0.82rem;
  text-align: center;
}

.ActionPlanBoardWidget_columnAction__npLCO {
  margin-top: 12px;
}

.ActionPlanBoardWidget_itemCard__fC7yX,
.ActionPlanBoardWidget_appointmentCard__9rH7C {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 14px;
  border: 1px solid #e2e7eb;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 3px 10px rgba(31, 54, 72, 0.05);
}

.ActionPlanBoardWidget_clickableCard__GEew0 {
  cursor: pointer;
  transition: transform 120ms ease, box-shadow 120ms ease;
}

.ActionPlanBoardWidget_clickableCard__GEew0:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(31, 54, 72, 0.09);
}

.ActionPlanBoardWidget_clickableCard__GEew0:focus-visible,
.ActionPlanBoardWidget_appointmentCard__9rH7C:focus-visible {
  outline: 3px solid rgba(21, 90, 168, 0.35);
  outline-offset: 2px;
}

.ActionPlanBoardWidget_itemCard__fC7yX strong,
.ActionPlanBoardWidget_appointmentCard__9rH7C > strong {
  color: #152f40;
  font-size: 0.9rem;
  line-height: 1.35;
}

.ActionPlanBoardWidget_cardTopRow__9Ab1r {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.ActionPlanBoardWidget_cardControls__aq18F {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.ActionPlanBoardWidget_deleteButton__3xUyF {
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 1px solid #d7dfe4;
  border-radius: 7px;
  background: #f5f7f8;
  color: #95a1a9;
  cursor: not-allowed;
}

.ActionPlanBoardWidget_deleteButton__3xUyF svg {
  width: 15px;
  height: 15px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.8;
}

.ActionPlanBoardWidget_deleteButton__3xUyF:disabled {
  opacity: 0.7;
}

.ActionPlanBoardWidget_valueBadge__L6O0E,
.ActionPlanBoardWidget_appointmentType__lqZwS,
.ActionPlanBoardWidget_status__T3imZ {
  display: inline-flex;
  align-items: center;
  min-height: 24px;
  padding: 3px 8px;
  border-radius: 999px;
  font-size: 0.7rem;
}

.ActionPlanBoardWidget_valueBadge__L6O0E[data-value="bienveillance"] {
  border: 1px solid var(--upcare-value-bienveillance);
  background: var(--upcare-value-bienveillance-soft);
  color: #8c6a00;
}

.ActionPlanBoardWidget_valueBadge__L6O0E[data-value="engagement"] {
  border: 1px solid var(--upcare-value-engagement);
  background: var(--upcare-value-engagement-soft);
  color: #17658f;
}

.ActionPlanBoardWidget_valueBadge__L6O0E[data-value="faire-equipe"] {
  border: 1px solid var(--upcare-value-faire-equipe);
  background: var(--upcare-value-faire-equipe-soft);
  color: #a20f4f;
}

.ActionPlanBoardWidget_valueBadge__L6O0E[data-value="respect"] {
  border: 1px solid var(--upcare-value-respect);
  background: var(--upcare-value-respect-soft);
  color: #1f7448;
}

.ActionPlanBoardWidget_appointmentType__lqZwS,
.ActionPlanBoardWidget_status__T3imZ {
  background: #f0f3f5;
  color: #667782;
}

.ActionPlanBoardWidget_themeBadge__biX8P {
  align-self: flex-start;
  padding: 4px 8px;
  border-radius: 999px;
  background: #eaf5f9;
  color: #245b72;
  font-size: 0.7rem;
  font-weight: 600;
}

.ActionPlanBoardWidget_requestOrganization__wSrgO {
  color: #667782;
  font-size: 0.76rem;
  font-weight: 600;
}

.ActionPlanBoardWidget_requestOrganizationName__D1-H9 {
  color: #315e73;
}

.ActionPlanBoardWidget_presenter__f5dXL {
  color: #687986;
  font-size: 0.78rem;
}

.ActionPlanBoardWidget_appointmentCard__9rH7C {
  cursor: pointer;
  border-top: 3px solid #8bb7ca;
  transition: transform 120ms ease, box-shadow 120ms ease;
}

.ActionPlanBoardWidget_appointmentCard__9rH7C[data-value="bienveillance"] {
  border-top-color: var(--upcare-value-bienveillance);
}

.ActionPlanBoardWidget_appointmentCard__9rH7C[data-value="engagement"] {
  border-top-color: var(--upcare-value-engagement);
}

.ActionPlanBoardWidget_appointmentCard__9rH7C[data-value="faire-equipe"] {
  border-top-color: var(--upcare-value-faire-equipe);
}

.ActionPlanBoardWidget_appointmentCard__9rH7C[data-value="respect"] {
  border-top-color: var(--upcare-value-respect);
}

.ActionPlanBoardWidget_appointmentCard__9rH7C:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(31, 54, 72, 0.09);
}

.ActionPlanBoardWidget_appointmentSummary__FIjSi {
  display: flex;
  gap: 10px;
  margin-top: 2px;
}

.ActionPlanBoardWidget_dateTile__wrQdI,
.ActionPlanBoardWidget_participantTile__mSys4 {
  min-width: 58px;
  min-height: 66px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 6px 8px;
  border-radius: 8px;
}

.ActionPlanBoardWidget_dateTile__wrQdI {
  border: 1px solid #2f6b86;
  background: #fff;
  color: #174c67;
}

.ActionPlanBoardWidget_dateTile__wrQdI strong {
  font-size: 1.15rem;
  line-height: 1;
}

.ActionPlanBoardWidget_dateTile__wrQdI span,
.ActionPlanBoardWidget_dateTile__wrQdI small,
.ActionPlanBoardWidget_participantTile__mSys4 small {
  font-size: 0.65rem;
}

.ActionPlanBoardWidget_participantTile__mSys4 {
  background: #eef2f4;
  color: #315e73;
}

.ActionPlanBoardWidget_participantTile__mSys4 > span {
  font-size: 1.1rem;
}

.ActionPlanBoardWidget_participantTile__mSys4 strong {
  font-size: 0.95rem;
}

.ActionPlanBoardWidget_registerButton__U1-nN,
.ActionPlanBoardWidget_registered__5a8m1,
.ActionPlanBoardWidget_full__Qonz8 {
  width: 100%;
  min-height: 40px;
  margin-top: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  font-size: 0.78rem;
  font-weight: 700;
}

.ActionPlanBoardWidget_registerButton__U1-nN {
  border: 0;
  background: #17677e;
  color: #fff;
  cursor: pointer;
}

.ActionPlanBoardWidget_registerButton__U1-nN:hover {
  background: #115469;
}

.ActionPlanBoardWidget_registered__5a8m1 {
  background: #def5e8;
  color: #1d7b4a;
}

.ActionPlanBoardWidget_full__Qonz8 {
  background: #edf0f2;
  color: #61717b;
}

@media (max-width: 1200px) {
  .ActionPlanBoardWidget_columns__tx0P3 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .ActionPlanBoardWidget_column__6sKaX:last-child {
    grid-column: 1 / -1;
  }
}

@media (max-width: 760px) {
  .ActionPlanBoardWidget_columns__tx0P3 {
    grid-template-columns: 1fr;
  }

  .ActionPlanBoardWidget_column__6sKaX,
  .ActionPlanBoardWidget_column__6sKaX:last-child {
    min-height: auto;
    grid-column: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ActionPlan/ActionPlanBoardWidget.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;;EAEE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;;EAEE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;;;EAGE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,mDAAmD;EACnD,kDAAkD;EAClD,cAAc;AAChB;;AAEA;EACE,gDAAgD;EAChD,+CAA+C;EAC/C,cAAc;AAChB;;AAEA;EACE,kDAAkD;EAClD,iDAAiD;EACjD,cAAc;AAChB;;AAEA;EACE,6CAA6C;EAC7C,4CAA4C;EAC5C,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,uDAAuD;AACzD;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;EAGE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,gBAAgB;IAChB,iBAAiB;EACnB;AACF","sourcesContent":[".board {\n  width: 100%;\n}\n\n.state,\n.error {\n  padding: 12px;\n  border-radius: 8px;\n  background: #fff;\n}\n\n.error {\n  color: #b42318;\n}\n\n.columns {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 16px;\n  align-items: stretch;\n}\n\n.column {\n  min-height: 500px;\n  display: flex;\n  flex-direction: column;\n  padding: 14px;\n  border: 1px solid #e2e7eb;\n  border-radius: 14px;\n  background: rgba(255, 255, 255, 0.58);\n}\n\n.highlighted {\n  box-shadow: inset 0 0 0 2px rgba(21, 90, 168, 0.12);\n}\n\n.columnHeader {\n  display: grid;\n  grid-template-columns: auto auto 1fr;\n  align-items: center;\n  gap: 9px;\n  margin-bottom: 12px;\n}\n\n.columnHeader h2 {\n  margin: 0;\n  color: #1c3445;\n  font-size: 1rem;\n  font-weight: 700;\n}\n\n.count {\n  justify-self: start;\n  color: #98a3ad;\n  font-size: 0.82rem;\n  font-weight: 700;\n}\n\n.columnIcon {\n  width: 30px;\n  height: 30px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  font-size: 1rem;\n  font-weight: 700;\n}\n\n.need {\n  background: #e8f5fb;\n  color: #2797c7;\n}\n\n.proposal {\n  background: #fff2e6;\n  color: #ff8b43;\n}\n\n.appointment {\n  background: #e9f9ef;\n  color: #2fac68;\n}\n\n.items {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.empty {\n  margin: 12px 0;\n  color: #87949e;\n  font-size: 0.82rem;\n  text-align: center;\n}\n\n.columnAction {\n  margin-top: 12px;\n}\n\n.itemCard,\n.appointmentCard {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 14px;\n  border: 1px solid #e2e7eb;\n  border-radius: 12px;\n  background: #fff;\n  box-shadow: 0 3px 10px rgba(31, 54, 72, 0.05);\n}\n\n.clickableCard {\n  cursor: pointer;\n  transition: transform 120ms ease, box-shadow 120ms ease;\n}\n\n.clickableCard:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 16px rgba(31, 54, 72, 0.09);\n}\n\n.clickableCard:focus-visible,\n.appointmentCard:focus-visible {\n  outline: 3px solid rgba(21, 90, 168, 0.35);\n  outline-offset: 2px;\n}\n\n.itemCard strong,\n.appointmentCard > strong {\n  color: #152f40;\n  font-size: 0.9rem;\n  line-height: 1.35;\n}\n\n.cardTopRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.cardControls {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.deleteButton {\n  width: 28px;\n  height: 28px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  border: 1px solid #d7dfe4;\n  border-radius: 7px;\n  background: #f5f7f8;\n  color: #95a1a9;\n  cursor: not-allowed;\n}\n\n.deleteButton svg {\n  width: 15px;\n  height: 15px;\n  fill: none;\n  stroke: currentColor;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-width: 1.8;\n}\n\n.deleteButton:disabled {\n  opacity: 0.7;\n}\n\n.valueBadge,\n.appointmentType,\n.status {\n  display: inline-flex;\n  align-items: center;\n  min-height: 24px;\n  padding: 3px 8px;\n  border-radius: 999px;\n  font-size: 0.7rem;\n}\n\n.valueBadge[data-value=\"bienveillance\"] {\n  border: 1px solid var(--upcare-value-bienveillance);\n  background: var(--upcare-value-bienveillance-soft);\n  color: #8c6a00;\n}\n\n.valueBadge[data-value=\"engagement\"] {\n  border: 1px solid var(--upcare-value-engagement);\n  background: var(--upcare-value-engagement-soft);\n  color: #17658f;\n}\n\n.valueBadge[data-value=\"faire-equipe\"] {\n  border: 1px solid var(--upcare-value-faire-equipe);\n  background: var(--upcare-value-faire-equipe-soft);\n  color: #a20f4f;\n}\n\n.valueBadge[data-value=\"respect\"] {\n  border: 1px solid var(--upcare-value-respect);\n  background: var(--upcare-value-respect-soft);\n  color: #1f7448;\n}\n\n.appointmentType,\n.status {\n  background: #f0f3f5;\n  color: #667782;\n}\n\n.themeBadge {\n  align-self: flex-start;\n  padding: 4px 8px;\n  border-radius: 999px;\n  background: #eaf5f9;\n  color: #245b72;\n  font-size: 0.7rem;\n  font-weight: 600;\n}\n\n.requestOrganization {\n  color: #667782;\n  font-size: 0.76rem;\n  font-weight: 600;\n}\n\n.requestOrganizationName {\n  color: #315e73;\n}\n\n.presenter {\n  color: #687986;\n  font-size: 0.78rem;\n}\n\n.appointmentCard {\n  cursor: pointer;\n  border-top: 3px solid #8bb7ca;\n  transition: transform 120ms ease, box-shadow 120ms ease;\n}\n\n.appointmentCard[data-value=\"bienveillance\"] {\n  border-top-color: var(--upcare-value-bienveillance);\n}\n\n.appointmentCard[data-value=\"engagement\"] {\n  border-top-color: var(--upcare-value-engagement);\n}\n\n.appointmentCard[data-value=\"faire-equipe\"] {\n  border-top-color: var(--upcare-value-faire-equipe);\n}\n\n.appointmentCard[data-value=\"respect\"] {\n  border-top-color: var(--upcare-value-respect);\n}\n\n.appointmentCard:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 16px rgba(31, 54, 72, 0.09);\n}\n\n.appointmentSummary {\n  display: flex;\n  gap: 10px;\n  margin-top: 2px;\n}\n\n.dateTile,\n.participantTile {\n  min-width: 58px;\n  min-height: 66px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 6px 8px;\n  border-radius: 8px;\n}\n\n.dateTile {\n  border: 1px solid #2f6b86;\n  background: #fff;\n  color: #174c67;\n}\n\n.dateTile strong {\n  font-size: 1.15rem;\n  line-height: 1;\n}\n\n.dateTile span,\n.dateTile small,\n.participantTile small {\n  font-size: 0.65rem;\n}\n\n.participantTile {\n  background: #eef2f4;\n  color: #315e73;\n}\n\n.participantTile > span {\n  font-size: 1.1rem;\n}\n\n.participantTile strong {\n  font-size: 0.95rem;\n}\n\n.registerButton,\n.registered,\n.full {\n  width: 100%;\n  min-height: 40px;\n  margin-top: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  font-size: 0.78rem;\n  font-weight: 700;\n}\n\n.registerButton {\n  border: 0;\n  background: #17677e;\n  color: #fff;\n  cursor: pointer;\n}\n\n.registerButton:hover {\n  background: #115469;\n}\n\n.registered {\n  background: #def5e8;\n  color: #1d7b4a;\n}\n\n.full {\n  background: #edf0f2;\n  color: #61717b;\n}\n\n@media (max-width: 1200px) {\n  .columns {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .column:last-child {\n    grid-column: 1 / -1;\n  }\n}\n\n@media (max-width: 760px) {\n  .columns {\n    grid-template-columns: 1fr;\n  }\n\n  .column,\n  .column:last-child {\n    min-height: auto;\n    grid-column: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"board": `ActionPlanBoardWidget_board__3cND8`,
	"state": `ActionPlanBoardWidget_state__xNLeu`,
	"error": `ActionPlanBoardWidget_error__yvvIP`,
	"columns": `ActionPlanBoardWidget_columns__tx0P3`,
	"column": `ActionPlanBoardWidget_column__6sKaX`,
	"highlighted": `ActionPlanBoardWidget_highlighted__NfUDr`,
	"columnHeader": `ActionPlanBoardWidget_columnHeader__omtGZ`,
	"count": `ActionPlanBoardWidget_count__hbJFy`,
	"columnIcon": `ActionPlanBoardWidget_columnIcon__V2eBz`,
	"need": `ActionPlanBoardWidget_need__ZrJI7`,
	"proposal": `ActionPlanBoardWidget_proposal__i4piK`,
	"appointment": `ActionPlanBoardWidget_appointment__XlfLy`,
	"items": `ActionPlanBoardWidget_items__2wNBh`,
	"empty": `ActionPlanBoardWidget_empty__RQ-HN`,
	"columnAction": `ActionPlanBoardWidget_columnAction__npLCO`,
	"itemCard": `ActionPlanBoardWidget_itemCard__fC7yX`,
	"appointmentCard": `ActionPlanBoardWidget_appointmentCard__9rH7C`,
	"clickableCard": `ActionPlanBoardWidget_clickableCard__GEew0`,
	"cardTopRow": `ActionPlanBoardWidget_cardTopRow__9Ab1r`,
	"cardControls": `ActionPlanBoardWidget_cardControls__aq18F`,
	"deleteButton": `ActionPlanBoardWidget_deleteButton__3xUyF`,
	"valueBadge": `ActionPlanBoardWidget_valueBadge__L6O0E`,
	"appointmentType": `ActionPlanBoardWidget_appointmentType__lqZwS`,
	"status": `ActionPlanBoardWidget_status__T3imZ`,
	"themeBadge": `ActionPlanBoardWidget_themeBadge__biX8P`,
	"requestOrganization": `ActionPlanBoardWidget_requestOrganization__wSrgO`,
	"requestOrganizationName": `ActionPlanBoardWidget_requestOrganizationName__D1-H9`,
	"presenter": `ActionPlanBoardWidget_presenter__f5dXL`,
	"appointmentSummary": `ActionPlanBoardWidget_appointmentSummary__FIjSi`,
	"dateTile": `ActionPlanBoardWidget_dateTile__wrQdI`,
	"participantTile": `ActionPlanBoardWidget_participantTile__mSys4`,
	"registerButton": `ActionPlanBoardWidget_registerButton__U1-nN`,
	"registered": `ActionPlanBoardWidget_registered__5a8m1`,
	"full": `ActionPlanBoardWidget_full__Qonz8`
};
export default ___CSS_LOADER_EXPORT___;
